module.exports = __webpack_public_path__ + "img/step6.9762d06d.png";